import React from 'react'
import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'
import { elementId } from './LocationFilter/PlacesLocationInput'
import { getFiltersCount } from './utils'

export const ClearButton = styled.button`
  border: none;
  background: none;
  color: ${Theme.colors.lightBlue};
  font-family: ${Theme.fonts.Montserrat};
  font-size: 12px;
  padding: 0;
  opacity: ${props => props.disabled ? 0.6 : 1};
  cursor: ${props => !props.disabled && 'pointer'};
`

const handleClear = (onSearchStateChange) => {
  const locationInput = document.getElementById(elementId)
  if (locationInput) locationInput.value = ''
  return onSearchStateChange({}, { clearAll: true })
}

const FilterClear = ({ searchState, onSearchStateChange, text = 'Clear All Filters' }) => {
  if (getFiltersCount(searchState) > 0) {
    return <ClearButton onClick={() => handleClear(onSearchStateChange)}>
      {text}
    </ClearButton>
  }
  return <ClearButton disabled>{text}</ClearButton>
}

export default FilterClear
